import { call, delay, race, take } from 'redux-saga/effects';
import { pingEvents } from '../services/events';

export const pingEvent = function* (eventId, token, action_ping_close = "NOT_ACTION") {
    try {

        let eventSucces = true;

        // TODO: This delay is here because, the event may not succeed yet in the api
        const { respClose_1 } = yield race({
            respDelay: delay(2000),
            respClose_1: take(action_ping_close),
        });


        if (respClose_1) {
            eventSucces = false;
            return { type: action_ping_close };
        }

        while (eventSucces) {

            const { respEvent: { data: { event } }, respClose_2 } = yield race({
                respEvent: yield call(pingEvents, eventId, token),
                respClose_2: take(action_ping_close),
            });


            if (respClose_2) {
                eventSucces = false;
                return { type: action_ping_close };
            }

            switch (event.status) {
                case 200:
                    eventSucces = false;
                    break;
                case 500:
                    eventSucces = false;
                    // eslint-disable-next-line no-throw-literal
                    throw {
                        response: { status: 500 }
                    };
                default:

                    const { respClose_3 } = yield race({
                        respDelay: yield delay(5000),
                        respClose_3: take(action_ping_close),
                    });

                    if (respClose_3) {
                        eventSucces = false;
                        return { type: action_ping_close }
                    }
            }

        };

        return true;
    } catch (error) {
        throw error;
    }
};